import React, { useReducer, useEffect } from 'react'
import { lockedReducer } from '../../Utils/reducers';
import { api } from '../../../services/api';
import validateData from "./validateData";
import { Box, Tooltip, TextField } from '@mui/material'
import DefaultModal from '../../Utils/DefaultModal';
import ColorButton from '../../Buttons/ColorButton';
import toast from 'react-hot-toast';
import MegaAutoComplete from '../../Utils/megautocomplete';

const url = '/acessos/'

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const submit = async (data, getData, setLoader, handleClose) => {

    setLoader(true)
    let res = null

    if (data.id)
        res = await api.patch(`${url}${data.id}/`, data)
    else
        res = await api.post(url, data)
    if (res.status === 201 || res.status === 200) {
        toast.success(`Acesso ${res.status === 201 ? 'adicionado' : 'editado'} com sucesso`)
        getData()
        handleClose()
        setLoader(false)
        return
    }
    toast.error(`Acesso não pôde ser ${!data.id ? 'adicionado' : 'editado.'} Motivo: ${res.data}`)
    setLoader(false)
}

const loadRetrieve = async (id, setState, setLoader) => {
    setLoader(true)
    const res = await api.get(url + `${id}/`)
    if (res.status === 200) {
        setState({ ...res.data })
    }
    setLoader(false)
}


const EditAcesso = ({ data, reloadData, setLoader, handleClose }) => {

    const [state, setState] = useReducer(lockedReducer, {
        nome: '',
        alas: [],
        pisos: [],
        catracas: [],

        ...data,
        id: data.id ? data.id : 0
    })

    const validData = validateData(state)

    useEffect(() => {
        if (data.id)
            loadRetrieve(data.id, setState, setLoader)

    }, [data.id])


    return (
        <>
            <DefaultModal
                open={true}
                title={
                    `${getTitle(state)} Acesso`
                }
                handleClose={handleClose}
                content={
                    <>
                        <Box className='item-content-modal noborder' >

                            <Box className='item-profile-row'>
                                <TextField
                                    id="name"
                                    type="text"
                                    label="Nome"
                                    value={state.nome}
                                    onChange={(e) => { setState({ 'nome': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                            </Box>

                            <Box className='item-profile-row'>
                                <MegaAutoComplete
                                    multiple={true}
                                    value={state.alas}
                                    onChange={(data) => setState({ alas: data })}
                                    noOptionsText={'Digite para procurar uma Ala'}
                                    timeoutUrl='/acessos/alas/'
                                    timeoutParam='label'
                                    label='Alas'
                                    sx={{ width: '20%' }}
                                />
                            </Box>

                            <Box className='item-profile-row'>
                                <MegaAutoComplete
                                    multiple={true}
                                    value={state.pisos}
                                    onChange={(data) => setState({ pisos: data })}
                                    noOptionsText={'Digite para procurar um piso'}
                                    timeoutUrl='/acessos/pisos/'
                                    timeoutParam='label'
                                    label='Pisos'
                                    sx={{ width: '20%' }}
                                />
                            </Box>

                            <Box className='item-profile-row'>
                                <MegaAutoComplete
                                    multiple={true}
                                    value={state.catracas}
                                    onChange={(data) => setState({ catracas: data })}
                                    noOptionsText={'Digite para procurar uma catraca'}
                                    timeoutUrl='/acessos/catracas/'
                                    timeoutParam='label'
                                    label='Catracas'
                                    sx={{ width: '20%' }}
                                />
                            </Box>

                        </Box>
                    </>
                }
                action={
                    <>
                        <Tooltip placement="left" title={validData}>
                            <Box>
                                <ColorButton
                                    onClick={() => submit(state, reloadData, setLoader, handleClose)}
                                    disabled={validData}
                                >Salvar
                                </ColorButton>
                            </Box>
                        </Tooltip>
                    </>
                }
            />

        </>
    )
}

export default EditAcesso;